// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__Kp-CF","spin":"spinner_spin__ILuXL"};